/** Session keys for post-OAuth GMC setup modal (Integrations page). */
export const GMC_OAUTH_SETUP_PENDING_KEY = 'payhelm_gmc_oauth_setup_pending'
export const GMC_OAUTH_SETUP_DISMISSED_KEY = 'payhelm_gmc_oauth_setup_dismissed'
export const GMC_OAUTH_TOAST_DONE_KEY = 'payhelm_gmc_oauth_toast_done'
export const GMC_ACTIVE_SETUP_CONNECTION_ID_KEY = 'payhelm_gmc_active_setup_connection_id'

const GMC_ACCOUNT_SETUP_DISMISSED_PREFIX = 'payhelm_gmc_account_setup_dismissed_'

function gmcAccountSetupDismissKey(connectionId: string): string {
  return `${GMC_ACCOUNT_SETUP_DISMISSED_PREFIX}${connectionId}`
}

export function isGmcAccountSetupDismissed(connectionId: string): boolean {
  if (!connectionId) return false
  try {
    return localStorage.getItem(gmcAccountSetupDismissKey(connectionId)) === '1'
  } catch {
    return false
  }
}

export function dismissGmcAccountSetup(connectionId: string): void {
  if (!connectionId) return
  try {
    localStorage.setItem(gmcAccountSetupDismissKey(connectionId), '1')
  } catch {
    /* ignore */
  }
}

export function clearGmcAccountSetupDismissed(connectionId: string): void {
  if (!connectionId) return
  try {
    localStorage.removeItem(gmcAccountSetupDismissKey(connectionId))
  } catch {
    /* ignore */
  }
}

export function clearAllGmcAccountSetupDismissed(): void {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(GMC_ACCOUNT_SETUP_DISMISSED_PREFIX))
      .forEach((key) => localStorage.removeItem(key))
  } catch {
    /* ignore */
  }
}

export function setGmcActiveSetupConnectionId(connectionId: string): void {
  if (!connectionId) return
  try {
    sessionStorage.setItem(GMC_ACTIVE_SETUP_CONNECTION_ID_KEY, connectionId)
  } catch {
    /* ignore */
  }
}

export function dismissGmcOAuthSetupModal(): void {
  try {
    sessionStorage.removeItem(GMC_OAUTH_SETUP_PENDING_KEY)
    sessionStorage.setItem(GMC_OAUTH_SETUP_DISMISSED_KEY, '1')
    const activeConnectionId = sessionStorage.getItem(GMC_ACTIVE_SETUP_CONNECTION_ID_KEY)
    if (activeConnectionId) {
      dismissGmcAccountSetup(activeConnectionId)
    }
    sessionStorage.removeItem(GMC_ACTIVE_SETUP_CONNECTION_ID_KEY)
  } catch {
    /* ignore */
  }
}

/** User is starting a fresh OAuth link — allow setup modal/toast again afterward. */
export function clearGmcOAuthSessionForNewConnect(): void {
  try {
    sessionStorage.removeItem(GMC_OAUTH_SETUP_DISMISSED_KEY)
    sessionStorage.removeItem(GMC_OAUTH_TOAST_DONE_KEY)
    sessionStorage.removeItem(GMC_OAUTH_SETUP_PENDING_KEY)
    sessionStorage.removeItem(GMC_ACTIVE_SETUP_CONNECTION_ID_KEY)
    clearAllGmcAccountSetupDismissed()
  } catch {
    /* ignore */
  }
}

export function isGmcOAuthSetupDismissed(): boolean {
  try {
    return sessionStorage.getItem(GMC_OAUTH_SETUP_DISMISSED_KEY) === '1'
  } catch {
    return false
  }
}
